import ApiService from "../../services/api.service";
import { Notify } from 'quasar';

export const apiSirene = {
  state: {
    sireneDatas: [],
    sireneData : null,
    object: null
  },
  mutations :{
    setSireneDatas(state, sireneDatas){
      state.sireneDatas = sireneDatas
    },
    setSireneData(state, sireneData){
      state.sireneData = sireneData
    }
  },
  actions: {
    /* Sirene Action GET */
    fecthSireneDatas(context, url)
    {
      return ApiService.getRequest(url).then(
        response => {
          context.commit('setSireneDatas', response.data)
          return response.data
        },
      )
        .catch(error =>{
          console.error(error);
          const status = error && error.status
          if(status === 404){
            Notify.create({
              message: "L'entreprise n'a pas été trouvée.",
              color: 'red'
            })
          } else if(status === 503) {
            Notify.create({
              message: "Le service est indisponible.",
              color: 'red'
            })
          } else {
            Notify.create({
              message: "Une erreur est survenue lors de la connexion à l'API.",
              color: 'red'
            })
          }
          return Promise.reject(error)
        })
    },
  },
  getters: {
    getSireneDatas(state) {
      return state.sireneDatas;
    },
    getSireneData(state){
      return state.sireneData;
    }
  }
}
